import Vue from 'vue'
import Toast from './Toast.vue'

const TOAST = Vue.extend(Toast)

// 创建Toast实例并挂载此实例
let instance 
const initInstance = () => {
  instance = new TOAST
  instance.$mount()
}

// 控制组件的展示
function showMsg(message, type, duration) {
  duration = duration && parseInt(duration) && parseInt(duration) > 0 ? parseInt(duration) : 3000
  const typeList = ['info', 'warn', 'success', 'error']
  type = typeList.includes(type)? type : 'info'
  instance || initInstance()

// 将外部传入的message等信息传入到组件实例中
  const toast = Object.assign(instance, {
    message,
    type,
    duration,
  })

// 调用实例的show()方法，实现组件的展示
  toast.show()
  return this
}

// 将调用方法暴露出去
export default {
  info(msg, duration) {
    showMsg(msg, 'info', duration)
  },
  success(msg, duration) {
    showMsg(msg, 'success', duration)
  },
  warn(msg, duration) {
    showMsg(msg, 'warn', duration)
  },
  error(msg, duration) {
    showMsg(msg, 'error', duration)
  },
}


// WEBPACK FOOTER //
// ./src/components/Toast/index.js